import { defineMessages } from 'react-intl';

export default defineMessages({
  userRfidModalScanQRAlertAllowCamera: {
    defaultMessage: 'Please allow camera access to scan the QR code.',
    id: 'userRfidModal.scanQR.alert.allowCamera',
  },
  userRfidModalScanQRAlertInvalidCode: {
    defaultMessage: "It looks like you're trying to scan an incorrect QR code.",
    id: 'userRfidModal.scanQR.alert.invalidCode',
  },
  userRfidModalScanQRAlertPermissionDenied: {
    defaultMessage: 'Your browser is blocking camera access. You must allow it.',
    id: 'userRfidModal.scanQR.alert.permissionDenied',
  },
  userRfidModalScanQRAlertTimeout: {
    defaultMessage: "We're unable to scan the code. Close scanner and type manually.",
    id: 'userRfidModal.scanQR.alert.timeout',
  },
  userRfidModalScanQRCloseBtn: {
    defaultMessage: 'Close scanner',
    id: 'userRfidModal.scanQR.closeBtn',
  },
  userRfidModalScanQRText: {
    defaultMessage: 'Use the code on the card / fob',
    id: 'userRfidModal.scanQR.text',
  },
  userRfidModalScanQRTitle: {
    defaultMessage: 'Scan QR code',
    id: 'userRfidModal.scanQR.title',
  },
});
